import { withStyles } from '@material-ui/styles';
import React from 'react';

import styles, {
  customSelectRowStyles,
  customInputStyles
} from '../styles/frontendSettings';
import { translate } from '../../../i18n/I18nProvider';
import SelectRow from '../../../partials/dataRows/SelectRow';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';
import InputRow from '../../../partials/dataRows/InputRow';

const Setup = ({ classes, form, clientsOptions, isNewPartner }) => {
  return (
    <div className={classes.root}>
      <div className={classes.title}>{translate('APP_SETTINGS.SETUP')}</div>
      <div className={classes.section}>
        <InputRow
          customStyles={customInputStyles}
          label="NAME"
          name="name"
          disabled={!isNewPartner}
          {...form}
        />
        <SelectRow
          name="selectedClientId"
          label="OWNER"
          options={clientsOptions}
          customStyles={customSelectRowStyles}
          isEditModal={false}
          {...form}
        />
      </div>
    </div>
  );
};
const mapStatesToProps = ({ appSettings }) => {
  return {
    clientsOptions: appSettings.clientsOptions
  };
};

export default flowRight(connect(mapStatesToProps), withStyles(styles))(Setup);
